var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.998047 12.3771V15.5021H4.12305L13.3397 6.28542L10.2147 3.16042L0.998047 12.3771ZM15.7564 3.86875C16.0814 3.54375 16.0814 3.01875 15.7564 2.69375L13.8064 0.74375C13.4814 0.41875 12.9564 0.41875 12.6314 0.74375L11.1064 2.26875L14.2314 5.39375L15.7564 3.86875Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.74aec9cb10140bfa28e8d422189f3019.svg";
export { ForwardRef as ReactComponent };